import type { CreateUnlockRequestPayload } from '../services/queries/creditBlockBureauQueries';
import type { CreditBlockCaseOrigin } from '../services/creditBlock/creditBlockCaseCreate';
import { CREDIT_BLOCK_SYSTEM_CASE_ORIGIN } from '../services/creditBlock/caseOriginDisplay';

export type NewCaseRequestKind = Exclude<CreateUnlockRequestPayload['requestType'], 'permanent_block'>;

/** UI + validation + default case fields per bureau request kind (header New case modal). */
export type CreditBlockNewCaseKindUiConfig = {
  showStartDate: boolean;
  showEndDate: boolean;
  startDateRequired: boolean;
  endDateRequired: boolean;
  reasonRequired: boolean;
  defaultPriority: 'Low' | 'Medium' | 'High';
  defaultOrigin: CreditBlockCaseOrigin;
  /** Short hint under request type buttons */
  hint?: string;
};

export const CREDIT_BLOCK_NEW_CASE_KIND_CONFIG: Record<NewCaseRequestKind, CreditBlockNewCaseKindUiConfig> = {
  unlock_request: {
    showStartDate: true,
    showEndDate: true,
    startDateRequired: false,
    endDateRequired: false,
    reasonRequired: false,
    defaultPriority: 'Medium',
    defaultOrigin: CREDIT_BLOCK_SYSTEM_CASE_ORIGIN,
    hint: 'Optional unblock window — leave dates empty if not applicable.',
  },
  lock_request: {
    showStartDate: true,
    showEndDate: false,
    startDateRequired: true,
    endDateRequired: false,
    reasonRequired: false,
    defaultPriority: 'Medium',
    defaultOrigin: CREDIT_BLOCK_SYSTEM_CASE_ORIGIN,
    hint: 'Lock effective date (start) is required; no end date on the request.',
  },
  permanent_unblock: {
    showStartDate: false,
    showEndDate: false,
    startDateRequired: false,
    endDateRequired: false,
    reasonRequired: false,
    defaultPriority: 'Medium',
    defaultOrigin: CREDIT_BLOCK_SYSTEM_CASE_ORIGIN,
  },
  extension: {
    showStartDate: true,
    showEndDate: true,
    startDateRequired: true,
    endDateRequired: true,
    reasonRequired: true,
    defaultPriority: 'Medium',
    defaultOrigin: CREDIT_BLOCK_SYSTEM_CASE_ORIGIN,
    hint: 'Extension requires start & end dates and a reason.',
  },
  special_case: {
    showStartDate: true,
    showEndDate: true,
    startDateRequired: false,
    endDateRequired: false,
    reasonRequired: true,
    defaultPriority: 'Medium',
    defaultOrigin: CREDIT_BLOCK_SYSTEM_CASE_ORIGIN,
    hint: 'Reason is required; add dates only if they apply.',
  },
};

export function getNewCaseKindConfig(kind: NewCaseRequestKind): CreditBlockNewCaseKindUiConfig {
  return CREDIT_BLOCK_NEW_CASE_KIND_CONFIG[kind];
}
